import { RouteRecordRaw } from 'vue-router'
import Layout from '@/views/layouts/index.vue'
import Service from '@/views/pages/service/index.vue'
import Home from '@/views/pages/home/index.vue'
import Task from '@/views/pages/task/index.vue'
import Center from '@/views/pages/center/index.vue'
import Information from '@/views/pages/information/index.vue'
export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: '/layout/home'
	},
	{
		path: '/ys',
		name: 'Ys',
		component: () => import('@/views/pages/privacy/ys.vue'),
		meta: { title: '隐私政策' }
	},
	{
		path: '/s-ys',
		name: 'Sys',
		component: () => import('@/views/pages/privacy/single-ys.vue'),
		meta: { title: '隐私政策' }
	},
	{
		path: '/s-fw',
		name: 'Sfw',
		component: () => import('@/views/pages/privacy/single-fw.vue'),
		meta: { title: '服务协议' }
	},
	{
		path: '/layout',
		name: 'Layout',
		redirect: '/layout/home',
		component: Layout,
		children: [
			{
				path: 'home',
				name: 'Home',
				component: Home,
				meta: { title: '首页', keepAlive: true, showTab: true }
			},
			{
				path: 'task',
				name: 'Task',
				component: Task,
				meta: { title: '任务中心', keepAlive: true, showTab: true }
			},
			{
				path: 'taskSearch',
				name: 'TaskSearch',
				component: () => import('@/views/pages/task/taskSearch.vue'),
				meta: { title: '任务搜索', keepAlive: false, showTab: true }
			},
			{
				path: 'service',
				name: 'Service',
				component: Service,
				meta: { title: '办事大厅', keepAlive: true, showTab: true }
			},
			{
				path: 'center',
				name: 'Center',
				component: Center,
				meta: { title: '个人中心', keepAlive: false, showTab: true }
			},
			{
				path: 'message',
				name: 'Message',
				component: () => import('@/views/pages/message/index.vue'),
				meta: { title: '消息中心', keepAlive: false, hideTitle: true, showTab: true }
			},
			{
				path: 'message-center',
				name: 'MessageCenter',
				component: () => import('@/views/pages/message/center.vue'),
				meta: { title: '网络中心', keepAlive: false, hideTitle: true, showTab: true }
			},
			{
				path: 'message-search',
				name: 'MessageSearch',
				component: () => import('@/views/pages/message/search.vue'),
				meta: { title: '消息搜索', keepAlive: false, hideTitle: true, showTab: true }
			},
			{
				path: 'more',
				name: 'More',
				component: () => import('@/views/pages/more/index.vue'),
				meta: { title: '更多', keepAlive: false, showTab: true }
			},
			{
				path: 'information',
				name: 'Information',
				component: Information,
				meta: { title: '资讯中心', keepAlive: true, showTab: true }
			},
			{
				path: 'information-search',
				name: 'InformationSearch',
				component: () => import('@/views/pages/information/search.vue'),
				meta: { title: '资讯搜索', keepAlive: false, showTab: true }
			},
			{
				path: 'service-search',
				name: 'ServiceSearch',
				component: () => import('@/views/pages/service/serviceSearch.vue'),
				meta: { title: '服务搜索', keepAlive: false, showTab: true }
			},
			{
				path: 'information-detail',
				name: 'InformationDetail',
				component: () => import('@/views/pages/information/detail.vue'),
				meta: { title: '资讯详情', keepAlive: false, showTab: false }
			},
			{
				path: 'application-page',
				name: 'ApplicationPage',
				component: () => import('@/views/pages/application-page/index.vue'),
				meta: { title: '', keepAlive: false, showTab: true }
			},
			{
				path: 'aboutUs',
				name: 'AboutUs',
				component: () => import('@/views/pages/about/index.vue'),
				meta: { title: '关于我们', keepAlive: true }
			},
			{
				path: 'infoDownload',
				name: 'InfoDownload',
				component: () => import('@/views/pages/information/InfoDownload.vue'),
				meta: { title: '文件下载', keepAlive: false, showTab: false }
			}
		]
	},
	{
		path: '/oauth',
		name: 'OAuth',
		component: () => import('@/views/pages/oAuth/index.vue'),
		meta: { title: '授权登录' }
	},
	{
		path: '/page',
		name: 'Page',
		redirect: '/page/testPage',
		meta: {
			title: '测试Page',
			keepAlive: false
		},
		component: Layout,
		children: [
			{
				path: 'appCasLogin',
				name: 'AppCasLogin',
				component: () => import('@/views/pages/appCasLogin/index.vue'),
				meta: { title: '登录', keepAlive: false }
			},
			{
				path: 'login',
				name: 'Login',
				component: () => import('@/views/pages/login/pwdLogin.vue'),
				meta: { title: '登录', keepAlive: false }
			},
			{
				path: 'taskRecord',
				name: 'TaskRecord',
				component: () => import('@/views/pages/task/taskRecord.vue'),
				meta: { title: '我发起的', keepAlive: false }
			},
			{
				path: 'userInfo',
				name: 'UserInfo',
				component: () => import('@/views/pages/center/userInfo.vue'),
				meta: { title: '个人信息', keepAlive: false }
			},
			{
				path: 'setting',
				name: 'Setting',
				component: () => import('@/views/pages/setting/index.vue'),
				meta: { title: '设置', keepAlive: false }
			}
		]
	}
]
